export default "__VITE_ASSET__CQrd5fza__"